const cacheVer =
  window.WPVUE && window.WPVUE.app_cache_version
    ? window.WPVUE.app_cache_version
    : new Date().getTime();

export default {
  /**
   * Check Things in background if something was cahnged during user is on page
   */
  appHearthBeatVersion({ state, dispatch, commit }) {
    axios
      .get("/wpvue/v2/getparams/version", {
        params: { nocache: cacheVer }
      })
      .then(res => {
        if (res && res.data && res.data === state.storeVersion) return true;
        else {
          console.log(
            "%c Cached data Update ...",
            "font-weight: bold; color: #9E175D"
          );
          commit("UPDATE_APP_VERSION", res.data);
          dispatch("wpGetEverything");
        }
      });
  },
  /**
   * Load page from cache
   */
  async loadAppCache({ commit, state }) {
    if (typeof Storage !== "undefined") {
      let storedData = localStorage.getItem(state.cacheKey);
      storedData = JSON.parse(storedData);
      if (
        storedData &&
        storedData.taxonomies &&
        storedData.wp_posts &&
        storedData.version &&
        storedData.version === state.storeVersion
      ) {
        commit("STORE_PAGE_DATA", storedData.wp_posts);
        commit("STORE_LOADED_TAXONOMIES", storedData.taxonomies);
        commit("LOADED_EVERYTHING", true);
        return true;
      }
    }
    return false;
  },
  /**
   *  Load everything from WP after 1st page is loaded
   */
  async wpGetEverything({ commit, getters }) {
    return axios
      .get("wpvue/v2/getpagedata/", {
        params: {
          nocache: cacheVer
        }
      })
      .then(res => {
        if (res.data) {
          let data = res.data;
          if (data.wp_posts) {
            commit("STORE_PAGE_DATA", data.wp_posts);
            commit("STORE_LOADED_TAXONOMIES", data.taxonomies);
            commit("LOADED_EVERYTHING", true);
            commit("UPDATE_PAGE_CACHE", data);
          }

          return res.data;
        } else {
          //console.log("GO 404");
          //window.location.pathname = '/404'
          return { status: "404" };
        }
      })
      .catch(res => {
        console.log(`Something went wrong (wpGetEverything): ${res}`);
      });
  },
  loadPage({ commit, getters }, payload) {
    let PTypeForRest = payload.postType === "page" ? "pages" : payload.postType; // in rest endpoint for pages is / pages but it return post_type page :/
    PTypeForRest = payload.postType === "post" ? "posts" : PTypeForRest; // same as above but for posts
    PTypeForRest = payload.postType === "attachment" ? "media" : PTypeForRest; // same as above but for attachemnts and media

    axios
      .get("wp/v2/" + PTypeForRest + "/" + payload.id, {
        params: payload.attrs
      })
      .then(res => {
        if (res.data) {
          commit("STORE_PAGE_DATA", [res.data]);
        }
      })
      .catch(res => {
        alert("Wrong password");
      });
  },
  /**
   * Load page by Current route
   */
  async getPageByRoute({ commit, getters }) {
    const router = getters.getCurrentRoute;
    if (!router) return fasle;
    const headers = {};
    const postType = router.meta.post_type;
    // we need custom load becasue we want dispaly  archive page as post type of this archve
    const pagePath = router.path;
    const pageUrl = (WPVUE.home_url + pagePath).replace(/\/$/, "");
    let loadById =
      router.meta.type !== "single" && router.meta.id
        ? "pages/" + router.meta.id
        : false;

    let apiUrl = "";
    let slug = null;

    let PTypeForRest = postType === "page" ? "pages" : postType; // in rest endpoint for pages is / pages but it return post_type page :/
    PTypeForRest = postType === "post" ? "posts" : PTypeForRest; // same as above but for posts
    PTypeForRest = postType === "attachment" ? "media" : PTypeForRest; // same as above but for attachemnts and media

    //check if it is preview
    const isPreview =
      router &&
      router.query &&
      router.query.preview &&
      router.query.preview === "1" &&
      router.query.page_id
        ? true
        : false;

    if (isPreview) {
      const featuredImage = router.query._thumbnail_id
        ? "?featured_image=" + router.query._thumbnail_id
        : "";
      PTypeForRest =
        PTypeForRest +
        "/" +
        router.query.page_id +
        "/revisions/" +
        router.query.revision_id +
        featuredImage;
      axios.defaults.headers.common["X-WP-Nonce"] = WPVUE.nonce;
    }

    if (loadById) {
      apiUrl = loadById; // archie pages ids or front page id
    } else {
      if (router.params.name) {
        slug = router.params.name.replace(/\/$/, "");
      }
      apiUrl = PTypeForRest;
    }

    let loadedData = null;

    await axios
      .get("wp/v2/" + apiUrl, {
        params: { slug, nocache: cacheVer }
      })
      .then(res => {
        if (res.data.length && !loadById) {
          loadedData = res.data.filter(
            item => pageUrl === item.link.replace(/\/$/, "")
          );
        }
        if ((loadById || isPreview) && res.data) {
          loadedData = [res.data];
          console.log({ loadedData });
          commit("STORE_PAGE_DATA", loadedData);
        } else if (loadedData && loadedData.length >= 1 && res.data.length) {
          commit("STORE_PAGE_DATA", loadedData);
          loadedData = loadedData[0];
        } else {
          console.warn("IS 404");
          loadedData = { status: "404" };
        }
      })
      .catch(res => {
        loadedData = { status: "404" };
        console.log(`Something went wrong (getPageByRoute) : ${res}`);
      });

    return loadedData;
  },

  /**
   *
   * @param {*} authorID ID of author from Wordpress backend
   */
  getAuthor({ commit, getters }, authorID) {
    if (!authorID) return false;
    let user = getters.getAuthorByID(authorID);
    if (!user) {
      axios
        .get("/wp/v2/users/" + authorID, {
          params: { nocache: cacheVer }
        })
        .then(res => {
          if (res.data) {
            commit("STORE_AUTHOR", res.data);
            user = res.data;
          } else {
            console.warn("Author not found:", authorID);
          }
        });
    }
    return user;
  }
};
